import { toast } from "@/components/ui/use-toast";
import { useMutateData } from "@/hooks/useMutation";
import { Folder } from "@/types/dashboard";
import { useState } from "react";

export function useFolderParcels(projectId: number) {
  const [currentFolder, setCurrentFolder] = useState<Folder | null>(null);

  const { mutate: saveFolder } = useMutateData({
    method: "POST",
    id: `folders-${projectId}`,
    onSuccess: (data: Folder) => {
      toast({ title: "✅ Dossier sauvegardé." });
      setCurrentFolder(data);
    },
    onError: () => {
      toast({
        title: "❌ Erreur lors de la sauvegarde du dossier.",
        className: "text-red-500",
      });
    },
  });

  const handleAddFolder = () => {
    saveFolder({
      endpoint: `${import.meta.env.VITE_API_ENDPOINT}/location-folder/save`,
      body: {
        project: projectId,
        name: "Nouveau dossier",
      },
    });
  };

  return {
    currentFolder,
    setCurrentFolder,
    handleAddFolder,
  };
}
